import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";


export default function ({ isOpen, handleClose, title='', link='' }: any) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  // document.addEventListener('contextmenu', event => event.preventDefault());
  
  useEffect(() => {
      
  },[])

  return (
    <Modal size="lg" fullscreen={true} show={isOpen} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <iframe id="fraDisabled" src={`${link}#toolbar=0&javascript:disableClick();`} style={{width:'100%', height: "100vh"}}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
  );
}
